import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectTitleCheckError, selectTitleCheckLoadingState } from '../../redux-state/titleCheck/selectors';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import CircularIndeterminate from '../../components/common/Progress';
import { SUBMIT_TITLE } from '../../redux-state/titleCheck/types';
import ErrorDialog from '../../components/common/error-dialog';
import { UPDATE_VEHICLE_INFO } from '../../redux-state/forms/types';
import { selectVehicleInfo } from '../../redux-state/selectors';
import FormValidation from '../../components/utility/formValidation';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import SecondaryButton from '../../components/common/button/SecondaryButton';

function TitleCheck({ formErrors }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const vehicleInfo = useSelector(selectVehicleInfo);
  const loadingState = useSelector(selectTitleCheckLoadingState);
  const [errors, setErrors] = useState({});
  const error = useSelector(selectTitleCheckError);

  const isMultiStep = location.state?.fromMultiStep;

  useEffect(() => {
    if (formErrors) {
      setErrors(formErrors);
    }
  }, [formErrors]);

  const isOutput = location.pathname.includes('titleOutput');
  if (isOutput) return <Outlet />;

  const handleSubmit = () => {
    const errors = FormValidation('Title', vehicleInfo);

    if (errors) {
      setErrors(errors);
      return;
    }

    setErrors({})

    const data = {
      vin: vehicleInfo.vinCode,
    };

    dispatch({
      type: SUBMIT_TITLE,
      payload: data,
      navigate: navigate,
    });
  };

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_VEHICLE_INFO,
      payload: { key, value },
    });
  };

  const handleSubmitBack = () => {
    navigate('/dashboard');
  };

  const handleCloseError = () => {
    dispatch({ type: 'CLEAR_TITLE_CHECK_ERROR' });
  };

  return (
    <>
      <div className="p-6 min-h-[600px]">
        <div className="mb-4">
          <CustomBreadcrumbs title="Lien & Title check" />
        </div>

        <div className="text-3xl font-bold text-gray-900 mb-2">
          Lien & Title check
        </div>

        <div className="text-gray-600 mb-4">
          Validate collateral using NMVTIS and state databases
        </div>

        <div className="bg-white w-full md:w-1/2 rounded-lg p-4">
          
          <div className="text-gray-600 text-sm mb-6">
            Add VIN number to start lien & title check
          </div>

          <div>
            <TextField
              required
              id="outlined-basic"
              label="VIN"
              variant="outlined"
              value={vehicleInfo.vinCode}
              onChange={(e) => handleChange('vinCode', e.target.value)}
              error={!!errors.vinCode}
              helperText={errors.vinCode}
              sx={{ width: '100%', maxWidth: 400 }}
              InputProps={{
                style: {
                  borderRadius: '10px',
                },
              }}
            />
          </div>
        </div>
      </div>

      {loadingState && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <CircularIndeterminate />
        </div>
      )}

      {!isMultiStep &&
        <div className="flex flex-row justify-between bg-white p-6">
          <SecondaryButton
            text="Back to Home"
            onClick={handleSubmitBack}
          />

          <PrimaryButton
            text="Submit"
            onClick={handleSubmit}
            disabled={loadingState}
          />
        </div>
      }
      <ErrorDialog backendError={error} onClose={handleCloseError} />
    </>
  );
}

export default TitleCheck;

